module.exports = __webpack_public_path__ + "img/james-search-animated.8c48e4f9.gif";